<template>
  <vs-popup class="add-additional-cost-popup"
            id="popup"
            :title="`UPDATE INVOICE (${product_order_code})`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdateInvoice)" autocomplete="off">

          <div class="vx-row mt-4 mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="date" name="date" rules="required" v-slot="{ errors }">
                <small class="label">Invoice date <span class="text-danger">*</span></small>
                <flat-pickr style="display: none" :config="{ dateFormat: 'd/m/Y'}" class="w-full" v-model="createForm.date"/>
                <flat-pickr :config="{ dateFormat: 'd/m/Y'}" class="w-full" v-model="createForm.date"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="createForm.note" height="70px"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <vs-table  class="mt-8" :data="invoice_data.items" :hoverFlat="true" :onlyClickCheckbox="true" multiple v-model="selectedItems">

            <template slot="header">
              <h5 class="mb-4">Select items</h5>
            </template>

            <template slot="thead">
              <vs-th>ITS PRODUCT CODE</vs-th>
              <vs-th>FG TYPE</vs-th>
              <vs-th width="10%">TOTAL ITEM QUANTITY (WITH RETURN STOCK) (KG)</vs-th>
              <vs-th width="10%">REMAINING QUANTITY (KG)</vs-th>
              <vs-th width="5%">QUANTITY (KG)</vs-th>
              <vs-th>UNIT PRICE Excl VAT (KG/{{ account_currency }})</vs-th>
              <vs-th>TOTAL PRICE Excl VAT ({{ account_currency }})</vs-th>
              <vs-th width="15%">TAX CODE</vs-th>
              <vs-th>NOMINAL CODE</vs-th>
              <vs-th>SAGE DEPARTMENT</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr_item"  :key="index_item" v-for="(tr_item, index_item) in data">

                <vs-td :data="tr_item.formulation_code">
                  {{ tr_item.formulation_code }}
                </vs-td>
                <vs-td :data="tr_item.formulation_type">
                  {{ tr_item.formulation_type }}
                </vs-td>
                <vs-td :data="tr_item.total_item_quantity_with_return">
                  {{ tr_item.total_item_quantity_with_return }}
                </vs-td>
                <vs-td :data="tr_item.remaining_to_be_quantity">
                  {{ tr_item.remaining_to_be_quantity }}
                </vs-td>

                <vs-td :data="tr_item.quantity">
                  <ValidationProvider :vid="index_item + 'selected_quantity' " :name="index_item + 'selected_quantity'" :rules="getMaxQtyRule(tr_item)" v-slot="{ errors }">
                 <vs-input v-model="tr_item.quantity" class="w-full" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/> 
                </ValidationProvider>
                </vs-td>

                <vs-td :data="tr_item.price">
                  {{ tr_item.price }}
                </vs-td>

                <vs-td :data="tr_item.quantity">
                  {{tr_item.quantity ? (Number(tr_item.price) * tr_item.quantity).toFixed(2) : '0.00'}}
                </vs-td>

                <vs-td>
                  <vs-dropdown>

                    <a class="flex items-center">
                      {{ tr_item.tax_code || 'SELECT'}}
                      <i class="material-icons"> expand_more </i>
                    </a>

                    <vs-dropdown-menu style="z-index: 99999">

                      <vs-dropdown-item @click="onClickTaxCode(tax_code.code, tax_code.percent, tr_item.id)" v-for="(tax_code, index) in tax_codes" :key="index">
                        <span>{{tax_code.code}} - {{tax_code.percent}} % </span>
                      </vs-dropdown-item>

                    </vs-dropdown-menu>
                  </vs-dropdown>
                </vs-td>

                <vs-td>
                    <select v-model="tr_item.sage_nominal_code_id" class="default-dropdown">
                      <option v-for="option in nominal_codes" :value="option.id">
                        {{ option.code }}
                      </option>
                    </select>
                </vs-td>

                <vs-td>
                    <select v-model="tr_item.sage_department_id" class="default-dropdown">
                      <option v-for="option in sage_departments" :value="option.id">
                        {{ option.name }}
                      </option>
                    </select>
                </vs-td>

              </vs-tr>
            </template>

          </vs-table>

          <vs-table noDataText="Click add to add additional cost" class="mt-8" :data="createForm.add_cost">

            <template slot="header">
              <h5 class="mb-4">Additional cost</h5>
              <div class="flex flex-wrap items-center justify-end mt-8">
                <vs-button @click.stop="onClickAddAddCost()" size="small" class="ml-auto mt-2 mb-4">Add</vs-button>
              </div>
            </template>

            <template slot="thead">
              <vs-th>NAME</vs-th>
              <vs-th>AMOUNT Excl VAT ({{ account_currency }})</vs-th>
              <vs-th>VAT PERCENTAGE (%)</vs-th>
              <vs-th>NOMINAL CODE</vs-th>
              <vs-th>SAGE DEPARTMENT</vs-th>
              <vs-th></vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="index_cost" v-for="(tr_cost, index_cost) in data">

                <vs-td :data="tr_cost.name">
                  <ValidationProvider :vid="index_cost+'name'" :name="index_cost+'name'"
                                      rules="required" v-slot="{ errors }">
                    <vs-input type="text" v-model="tr_cost.name"
                              class="w-full"
                              :name="index_cost+'name'" :danger="!!errors[0]" :danger-text="errors[0]"
                              val-icon-danger="icon-x"
                              val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td :data="tr_cost.amount_ex_vat">
                  <ValidationProvider :vid="index_cost+'amount_ex_vat'" :name="index_cost+'amount_ex_vat'"
                                      rules="required" v-slot="{ errors }">
                    <vs-input type="text" v-model="tr_cost.amount_ex_vat"
                              class="w-full"
                              :name="index_cost+'amount_ex_vat'" :danger="!!errors[0]" :danger-text="errors[0]"
                              val-icon-danger="icon-x"
                              val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td :data="tr_cost.vat_percent">
                  <ValidationProvider :vid="index_cost+'vat_percent'" :name="index_cost+'vat_percent'"
                                      rules="required" v-slot="{ errors }">
                    <vs-input type="text" v-model="tr_cost.vat_percent"
                              class="w-full"
                              :name="index_cost+'vat_percent'" :danger="!!errors[0]" :danger-text="errors[0]"
                              val-icon-danger="icon-x"
                              val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td>
                    <select v-model="tr_cost.sage_nominal_code_id" class="default-dropdown">
                      <option v-for="option in nominal_codes" :value="option.id">
                        {{ option.code }}
                      </option>
                    </select>
                </vs-td>

                <vs-td>
                    <select v-model="tr_cost.sage_department_id" class="default-dropdown">
                      <option v-for="option in sage_departments" :value="option.id">
                        {{ option.name }}
                      </option>
                    </select>
                </vs-td>

                <vs-td>
                  <div class="vx-row">
                    <vx-tooltip class="ml-2" text="Remove" position="top">
                      <vs-button @click.stop="onClickRemoveAddCost(index_cost)"
                                 size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>

              </vs-tr>
            </template>

          </vs-table>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  const CustomerRepository = RepositoryFactory.get('customer')
  const TaxRepository = RepositoryFactory.get('tax')
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');

  function initialState() {
    return {
      open: false,
      invoice_id: '',
      product_order_code: '',
      invoice_data: {
        items:[]
      },
      createForm: {
        add_cost: []
      },
      formulation_items: [],
      order_invoices: [],
      account_currency: '',
      selectedItems: [],
      add_cost: [],
      tax_codes: [],
      nominal_codes: [],
      sage_departments: [],
      created_credit_note: [],
      selectedItems:[]
    }
  }

export default {
  name: 'UpdateProductOrderInvoicePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id,product_order_code, account_currency = 'GBP', formulation_items, invoice_data, order_invoices, created_credit_note = []) {
      
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        Object.assign(this.formulation_items, formulation_items)
        Object.assign(this.invoice_data, invoice_data)
        this.product_order_code = product_order_code
        this.account_currency = account_currency
        this.invoice_id = invoice_data.id
        this.order_invoices = order_invoices
        this.created_credit_note = created_credit_note
        

        // map with existing data
        this.createForm.date = invoice_data.date
        this.createForm.note = invoice_data.note
        this.createForm.add_cost = invoice_data.add_cost.map((n) => {
          n.sage_nominal_code_id = n.sage_nominal_code ? n.sage_nominal_code.id : null
          n.sage_department_id = n.sage_department ? n.sage_department.id : null
          return n
        })
        this.invoice_data.items = this.invoice_data.items.map((n) => {
          let find = this.formulation_items.find((m) => m.formulation_code === n.formulation_code)
          n.item_id = find.id
          n.sage_nominal_code_id = n.sage_nominal_code ? n.sage_nominal_code.id : null
          n.sage_department_id = n.sage_department ? n.sage_department.id : null
          return n
        })
        // invoice_data.items.forEach((n) => {
        //   this.formulation_items.forEach((m) => {
        //     if(m.formulation_code === n.formulation_code) {
        //       this.selectedItems.push(m)
        //     }
        //   })
        // })
        this.selectedItems = this.selectedItems.concat(this.invoice_data.items)
        await this.fetchFormulationItems(id,formulation_items,product_order_code, account_currency )
        await this.fetchTaxCodes()
        await this.fetchNominalCodes()
        await this.fetchSageDepartments()

        this.open = true;
      } catch (error) {
      }
    },
    getMaxQtyRule(item){

      
      const formulation = this.formulation_items.find(
        x => x.formulation_code === item.formulation_code
      );
      return `max_qty:${formulation.quantity}`
    },
    async fetchFormulationItems(id,formulation_items, product_order_code, account_currency){
      try {
        this.formulation_items = formulation_items.filter((x) => x.item_status !== 'Cancelled')
      this.order_invoices = this.order_invoices.filter((x) => x.status.name !== 'Cancelled')
      this.product_order_code = product_order_code
      this.account_currency = account_currency

      let inv_items = []
        this.order_invoices.forEach((n) => {
          inv_items = inv_items.concat(n.items)
      })

      this.formulation_items = this.formulation_items.map((x) => {
          const return_total = x.return_stock.filter((y) => !!y.is_quantity_reassigned).reduce((a, b) => a + Number(b.quantity), 0)
          x.return_stock_quantity = return_total
          x.sage_nominal_code_id = null
          x.sage_nominal_code = null
          return x
        })
        this.formulation_items.forEach((n) => {
          let related_inv = inv_items.filter((m) => n.formulation_code === m.formulation_code)
          let related_inv_total = related_inv.reduce((a, b) => a + Number(b.quantity), 0)
          let return_total = n.return_stock.filter((y) => !!y.is_quantity_reassigned).reduce((a, b) => a + Number(b.quantity), 0)

          let reassigned_return_total = n.return_stock.filter((y) => !!y.is_quantity_reassigned).reduce((a, b) => a + Number(b.quantity), 0)

          n.quantity = Number(n.quantity) - Number(return_total) + Number(reassigned_return_total)

          let related_credit_note_total = 0
          if(this.created_credit_note.length > 0) {
            const product_items = this.created_credit_note.filter((x) => x.status !== 'Invalid' ).flatMap((obj) => obj.product_items || []);
            let related_credit_notes = product_items.filter((x) => x.product_order_item_id === n.id)
            related_credit_note_total = related_credit_notes.reduce((total, { batches, total_quantity }) => {
              if(!batches || batches.length === 0) {
                batches = [{ quantity: total_quantity }]
              }
              return batches.reduce((sum, {quantity}) => sum + parseFloat(quantity), total);
            }, 0);
          }

          n.remaining_to_be_quantity = Number(n.quantity) - Number(related_inv_total) + related_credit_note_total
          n.selected_quantity = n.remaining_to_be_quantity
          n.tax_code = 'Z'
          n.tax_percent = '0.00'
          return n
        })
        // this.formulation_items = this.formulation_items.filter(x => x.remaining_to_be_quantity > 0)

        const formattedFormulationItems = this.formulation_items
        .filter(x => x.remaining_to_be_quantity > 0)
        .map(item => ({
          ...item,
          item_id: item.id,
          total_item_quantity_with_return: item.quantity,
          quantity: 0,
          sage_department: "",
          sage_department_id: null
        }));

        this.invoice_data.items = this.invoice_data.items.concat(formattedFormulationItems)

      } catch (error) {
      }
    },
    onClickAddAddCost() {
      this.createForm.add_cost.push({ name: null, amount: null })
    },
    onClickRemoveAddCost(index) {
      this.createForm.add_cost.splice(index, 1)
    },
    async fetchTaxCodes() {
      this.$vs.loading()
      try {
        const { data } =  await TaxRepository.getListOfTaxCodes(1, '', 150)
        this.tax_codes = data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    onClickTaxCode(code, percent, id) {
      this.invoice_data.items = this.invoice_data.items.map((x) => {
        if(x.id === id) {
          x.tax_code = code
          x.tax_percent = percent
        }
        return x
      })
    },

    async onClickUpdateInvoice () {
      const vue = this;
      this.$vs.loading()
       try {
         let payload = {}
         Object.assign(payload, this.createForm)
         payload.add_cost = payload.add_cost.map((n) => {
           return {
             amount: Number(n.amount_ex_vat).toFixed(2),
             vat_percent : Number(n.vat_percent).toFixed(2),
             name: n.name,
             sage_nominal_code_id: n.sage_nominal_code_id || null,
             sage_department_id: n.sage_department_id || null
           }
         })
         payload.items = this.selectedItems.map((x) => {
           return {
             customer_product_order_item_id: x.item_id,
             quantity: x.quantity,
             price: x.price,
             tax_code: x.tax_code,
             tax_percent: x.tax_percent,
             sage_nominal_code_id: x.sage_nominal_code_id || null,
             sage_department_id: x.sage_department_id || null
           }
         })
         await CustomerRepository.updateInvoice(this.invoice_id, payload)
         this.showSuccessMessage('Invoice updated successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.convertAndNotifyError(e)
         this.$vs.loading.close()
       }
      this.$vs.loading.close()
    },
    async fetchNominalCodes() {
      try {
        const { data } = (await SageSettingsRepository.getListOfSageNominalCodes(1, ``, 150, 0)).data
        this.nominal_codes = data
      } catch (error) {
        
      }
    },
    async fetchSageDepartments() {
      try {
        const { data } = (await SageSettingsRepository.getListOfSageDepartments(1, ``, 150, 0)).data
        this.sage_departments = data
      } catch (error) {
        
      }
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    flatPickr,
  }
}
</script>

<style scoped>
  .add-additional-cost-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 70% !important;
  }
</style>
